<div class="signaalkaart-antwoord-header">
  <div class="titel">
    <div class="mat-subtitle-1">{{signaalkaart.getTitel()}}</div>
    <div>{{signaalkaart.getCategorie()}}</div>
    <div>{{signaalkaartAntwoord.getCreatieTijdstip() | date: 'd MMMM yyyy'}}</div>
  </div>
  <div>
    @if (client) {
      <span class="mat-subtitle-1">{{client.getNaam()}}</span>
    }
    @if (client) {
      <span> ({{client.getNummer()}})</span>
    }
  </div>
</div>
